import { render, staticRenderFns } from "./bbsAttr.vue?vue&type=template&id=4bf03097&"
import script from "./bbsAttr.vue?vue&type=script&lang=js&"
export * from "./bbsAttr.vue?vue&type=script&lang=js&"
import style0 from "./bbsAttr.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports